export default __webpack_public_path__ + "static/media/Vijay.cd05bbd4.png";